import React from 'react';
import '../../styles/project.css'; // Import Project specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const benefitsData = [
  {
    number: '01',
    title: 'Custom Planning',
    description: 'Tailored project solutions designed to meet unique requirements and complex logistics challenges.',
    icon: 'fa-cogs'
  },
  {
    number: '02',
    title: 'Expert Handling',
    description: 'Specialized teams with deep knowledge in managing oversized cargo and complex projects.',
    icon: 'fa-users'
  },
  {
    number: '03',
    title: 'Safe Transport',
    description: 'Secure delivery of heavy cargo through coordinated logistics and safety protocols.',
    icon: 'fa-shield-alt'
  },
  {
    number: '04',
    title: 'Full Compliance',
    description: 'Complete handling of permits, regulations, and industry standards for seamless operations.',
    icon: 'fa-balance-scale'
  }
];

const ProjectBenefits = () => {
  return (
    <>
      {/* Project Benefits Section */}
      <section id="benefits" className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">WHY CHOOSE US</div>
            <h2 className="section-title">Project Benefits</h2>
            <p className="section-description">
              Discover the key advantages of partnering with RCS Logistics for your project cargo needs.
            </p>
          </div>

          <div className="services-cards-grid project-benefits">
            {benefitsData.map((benefit, index) => (
              <div key={index} className="service-card">
                <div className="service-card-icon">
                  <i className={`fas ${benefit.icon}`}></i>
                </div>
                <h3 className="service-card-title">{benefit.title}</h3>
                <p className="service-card-description">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectBenefits;